import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FileUpload, FileUploadErrorEvent } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { ProgressSpinner } from 'primeng/progressspinner';

interface UploadEvent {
  originalEvent: Event;
  files: File[];
}

@Component({
  selector: 'app-upload-xls',
  templateUrl: './upload-xls.component.html',
  styleUrl: './upload-xls.component.scss',
  standalone: true,
  imports: [FileUpload, ToastModule, CommonModule, ProgressSpinner],
  providers: [MessageService],
})
export class UploadXlsComponent {
  uploadFile?: File = undefined;
  isLoading = false;
  uploadEndpoint = '/api/v1/upload';

  constructor(private messageService: MessageService) {}

  onUpload() {
    this.isLoading = false;

    this.messageService.add({
      severity: 'info',
      summary: 'File Uploaded',
      detail: '',
    });
  }

  onErrorUpload(event: FileUploadErrorEvent) {
    this.isLoading = false;

    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: event.error?.message,
    });
  }

  onSend() {
    this.isLoading = true;

    this.messageService.add({
      severity: 'info',
      summary: 'File is uploading, please wait',
      detail: '',
    });
  }
}
